// v0.6.12 A5-27 — the "pick, don't write" select, shared.
// A2-571 (operator 2026-10-27: "We should not give options of free text only
// select dropdown"): the typed "Other" option is gone, so no caller's
// free-text box can open. The preset text is the submitted value.
//
// The pattern was born in review_queue/PerRowResolver.jsx: a list of
// ready-made reasons. Sixteen more boxes now follow it, so the select
// lives here once instead of being pasted sixteen times — the copies
// would drift (one already had: BulkResolveByCalc reset the preset but
// not the note on one of its three radios).
//
// The caller keeps two pieces of state, exactly as PerRowResolver does:
//   preset — "" | a preset string
//   value  — the text that is actually submitted
// onPick(preset, value) hands back both; value is the preset text.
//
// `blankLabel` replaces "Choose a reason…" where an empty answer is a
// real choice (an optional note), not an unanswered question.
import React from "react";
import { useTranslation } from "react-i18next";

const SELECT_CLS =
  "w-full bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 "
  + "text-slate-900 dark:text-slate-100 rounded px-2 py-1 text-xs";

export const PresetReasonSelect = ({
  testid, presets, preset, onPick, disabled = false, blankLabel = null,
  className = "", "aria-label": ariaLabel,
}) => {
  const { t } = useTranslation();
  return (
    <select
      data-testid={testid}
      value={preset}
      disabled={disabled}
      aria-label={ariaLabel || t("ui.review_grouped.reason_pick", {
        defaultValue: "Choose a reason…",
      })}
      onChange={(e) => {
        const v = e.target.value;
        onPick(v, v);
      }}
      className={`${SELECT_CLS} ${className}`}
    >
      <option value="">
        {blankLabel || t("ui.review_grouped.reason_pick", {
          defaultValue: "Choose a reason…",
        })}
      </option>
      {(presets || []).map((r) => (
        <option key={r} value={r}>{r}</option>
      ))}
    </select>
  );
};

export default PresetReasonSelect;
